module.exports = __webpack_public_path__ + "img/head_a.92684217.png";